import type { StaffCatalogItemStatus } from "@lafayette/schemas";

import { StatusBadge, type StatusTone } from "../../ui/status-badge";
import { itemStatusLabels, statusGlyphs } from "../labels";

const tones: Readonly<Record<StaffCatalogItemStatus, StatusTone>> = {
  DRAFT: "neutral",
  REVIEW: "warning",
  PUBLISHED: "success",
  UNPUBLISHED: "neutral",
  ARCHIVED: "neutral",
};

/** The status of a catalog item as a glyph and a word: it never depends on colour alone. Each status has its own glyph. */
export function ItemStatusBadge({ status }: Readonly<{ status: StaffCatalogItemStatus }>) {
  return (
    <span data-status={status} className="inline-flex">
      <StatusBadge tone={tones[status]} glyph={statusGlyphs[status]}>
        {itemStatusLabels[status]}
      </StatusBadge>
    </span>
  );
}
